import { useSortable } from '@dnd-kit/sortable'
import * as React from 'react'
import { FC, useMemo } from 'react'
import { CSS } from '@dnd-kit/utilities'
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'

interface RowContextProps {
    setActivatorNodeRef?: (element: HTMLElement | null) => void
    listeners?: SyntheticListenerMap
}

export const RowContext = React.createContext<RowContextProps>({})

interface CustomRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    'data-row-key': string
}

const CustomRow: FC<CustomRowProps> = props => {
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: props['data-row-key'] })

    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Translate.toString(transform),
        transition,
        ...(isDragging ? { position: 'relative', zIndex: 1000 } : {}),
    }

    const contextValue = useMemo<RowContextProps>(
        () => ({ setActivatorNodeRef, listeners }),
        [setActivatorNodeRef, listeners]
    )

    return (
        <RowContext.Provider value={contextValue}>
            <tr {...props} ref={setNodeRef} style={style} {...attributes} />
        </RowContext.Provider>
    )
}

export default CustomRow
